import { PageLoader, PrimaryButton, VerticalContainer } from '@american-autonomy/rantizo-ui';

import StripeSubscriptionCard from 'components/cards/StripeSubscriptionCard';
import ButtonsContainer from 'components/containers/ButtonsContainer';

import useData from './hooks/useData';
import useDisplaySubscriptionButtons from './hooks/useDisplaySubscriptionButtons';
import useTranslation from './hooks/useTranslation';

import { STRIPE_PREMIER_PRICING_TABLE_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StripeSubscriptionSummary: FunctionComponent<Props> = ({ setTableKey, testId = TEST_ID }) => {
    const { MANAGE_SUBSCRIPTION, UPGRADE_SUBSCRIPTION } = useTranslation();
    const { fetchCustomerPortalSessionUrl, isLoading, stripeSubscription } = useData();
    const { displayManageSubscriptionButton, displayUpgradeSubscriptionButton } =
        useDisplaySubscriptionButtons({ stripeSubscription });

    const handleDisplayPremierTable = () => {
        setTableKey(STRIPE_PREMIER_PRICING_TABLE_ID);
    };

    const handleManageSubscription = async () => {
        const result = await fetchCustomerPortalSessionUrl();
        const portalUrl = result?.portalUrl;

        if (portalUrl) {
            window.location.href = portalUrl;
        }
    };

    return (
        <VerticalContainer testId={testId}>
            {isLoading && <PageLoader />}

            {!isLoading && (
                <>
                    <ButtonsContainer className={styles.buttonsContainer}>
                        {displayUpgradeSubscriptionButton && (
                            <PrimaryButton
                                onClick={handleDisplayPremierTable}
                                text={UPGRADE_SUBSCRIPTION}
                            />
                        )}

                        {displayManageSubscriptionButton && (
                            <PrimaryButton
                                onClick={handleManageSubscription}
                                text={MANAGE_SUBSCRIPTION}
                            />
                        )}
                    </ButtonsContainer>

                    <StripeSubscriptionCard stripeSubscription={stripeSubscription} />
                </>
            )}
        </VerticalContainer>
    );
};

export default StripeSubscriptionSummary;
